import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CardMarkerSmall from '../../../components/CockpitCards/CardMarkerSmall';
import VaccsActions from "./VaccsRecords/VaccsActions";
import { format } from "d3-format"
import { useTheme } from "@mui/material";

export default function SectionVaccsCard1(data) {

const theme = useTheme();
const vaccnumber = data.data

return (
<>

{theme.palette.mode === "light" ? (

<CardMarkerSmall
  
headline="VACCINATIONS"  
subtext="Here you see a summary of all your vaccinations when pressing the LIST button. In case of new vaccinations just click on the ADD button to complete your vaccination list."

cardlines = {<>      

  <Grid container sx={{ p:2, bgcolor: 'grey.C100', borderRadius: '10px'  }}>  

     <Grid item xs={9} sx={{display:'flex', alignItems:'flex-end' }} >

        <Typography variant="h1" color='primary.light' sx={{fontFamily: 'Poppins', fontWeight: '400', color: 'traffic.green', 
                            }}> 
                    
                    {format(",")(vaccnumber)} 
                    <Typography component="span" variant="body1">&nbsp;total vaccs </Typography>
         </Typography>
     </Grid>

     <Grid item xs={2} > <VaccsActions />  </Grid> 
            
 </Grid>

    </>}   
    />    

) : (

    <CardMarkerSmall
  
        headline="VACCINATIONS"  
        subtext="Here you see a summary of all your vaccinations when pressing the LIST button. In case of new vaccinations just click on the ADD button to complete your vaccination list."
        
        cardlines = {<>      
        
            <Grid container sx={{ p:2, bgcolor: 'secondary.C800', borderRadius: '10px'  }}>  
        
            <Grid item xs={9} sx={{display:'flex', alignItems:'flex-end' }} >
        
                <Typography variant="h1" color='primary.light' sx={{fontFamily: 'Poppins', fontWeight: '400', color: 'traffic.green', 
                                    }}> 
                            
                            {format(",")(vaccnumber)} 
                            <Typography component="span" variant="body1">&nbsp;total vaccs </Typography>
                </Typography>
            </Grid>
        
            <Grid item xs={2} > <VaccsActions />  </Grid> 
                    
        </Grid>
  
      </>}   
      />    

)}

        
    </>
    )};
  